// extracted by mini-css-extract-plugin
export default {"container":"ErrorBox2_container__mkzK-","minimal":"ErrorBox2_minimal__2PZIR","standard":"ErrorBox2_standard__UmJca","text":"ErrorBox2_text__q6KvV","hidden":"ErrorBox2_hidden__zF62F"};